import React, { Component } from 'react';
import { connect } from 'react-redux';
import DocumentMeta from 'react-document-meta';
import { setCitySlug } from '../redux/modules/cities';
import { search } from '../redux/modules/dwellings';
import { Grid } from 'react-bootstrap';
import EmailSignup from '../common/email-signup';
import DwellingsList from './dwellings-list';
import i18n from 'kodyl-js/i18n/react';

function capitalize(s) {
  return s[0].toUpperCase() + s.slice(1);
}

@connect(
  ({ cities, dwellings: { meta, data, firstView, loading }, search }) => ({
    city: cities.current,
    data,
    meta,
    loading,
    search,
    dwellings: { data, firstView, loading }
  })
)
@i18n
class Search extends Component {
  static fetchData({ dispatch, location, reload }) {
    const { query } = location;
    if (query.q) {
      const promises = [
        dispatch(setCitySlug(query.q)),
        dispatch(search(query, { reload }))
      ];
      return __CLIENT__ ? null : Promise.all(promises);
    }
  }

  render() {
    const {
      city,
      meta,
      location,
      data,
      search,
      dwellings,
      loading
    } = this.props;
    const area = (city && city.label) || capitalize(location.query.q);

    const title = this.i18n(
      'Lejeboliger %1$s - viser nu ledige lejligheder nær %1$s',
      area
    );

    const docMeta = {
      title: `${title}${title.length > 45 ? '. Boligninja.dk' : ''}`,
      description: null,
      extend: true,
      auto: {
        ograph: true
      }
    };

    const searchStr = search
      ? [
          search.q,
          search.rent && `${this.i18n('max')} ${search.rent} kr.`,
          search.rooms &&
            `${this.i18n('min')} ${search.rooms} ${this.i18n('rooms')}`,
          search.size && `${this.i18n('min')} ${search.size} ${this.i18n('m2')}`
        ]
          .filter(Boolean)
          .join(', ')
      : null;

    const headline = this.i18n('Dwellings found: %s', meta.results || false);

    return (
      <DocumentMeta {...docMeta}>
        <div className="content">
          <Grid className="listings-container">
            <h1>
              {data.length || loading
                ? this.i18n(
                    'Rental dwellings %1$s - listing all available dwellings near %1$s',
                    area
                  )
                : this.i18n(
                    'Ingen lejeboliger fundet på valgte søgning nær %1$s',
                    area
                  )}
            </h1>
            {searchStr ? (
              <h4>{`${this.i18n('Din søgning:')} ${searchStr}`}</h4>
            ) : null}

            {city ? <EmailSignup area={city} city={area} headline /> : null}

            <DwellingsList
              headline={headline}
              {...dwellings}
              totalResults={meta.results}
            />

            <br />
            {city ? <EmailSignup area={city} city={area} /> : null}
          </Grid>
        </div>
      </DocumentMeta>
    );
  }
}

export default Search;
